import { startAuthentication } from 'app/keycloak';

async function isServerUnavailable() {
    try {
        const response = await fetch('/status');
        const { data } = await response.json();
        return Boolean(data.maintenanceStarted || data.suspended);
    } catch {
        return false;
    }
}

export async function start() {
    if (!(await isServerUnavailable())) {
        await startAuthentication().catch(() => {});
    }

    const { mount } = await import('app/main.js');

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mount);
    } else {
        mount();
    }
}
